type LocalStorageValueType = string | number | boolean | Record<string, string>

export function setLocalStorageValue(key: string, value: LocalStorageValueType) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error('Local storage is disabled for this user agent', error)
  }
}
